import React from "react";
import PaymentListComponent from "@components/User/Payment/PaymentList/PaymentList";

export default function PaymentList() {
  return <PaymentListComponent />;
}
